import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import Input from "../../../form/component/Input";
import currentUserHasAccess from '../../../../util/widget-helper'
import {MOVEMENT_CERTIFICATE_NUMBER_WIDGET} from "../../../process/ui-definition/process-ui";
import ValidationMessageList from "../../../validation/component/ValidationMessageList";

const MovementCertificateNumberWidget = ({readOnly, context, changeProcessContext, saveProcessContext, validationMessageList}) => {
    if (!currentUserHasAccess(MOVEMENT_CERTIFICATE_NUMBER_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Movement Certificate Number">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row>
                <Column size={12}>
                    <Input
                        readOnly={readOnly}
                        name="movementCertificateNumber"
                        object={context}
                        onChange={changeProcessContext}
                        onBlur={saveProcessContext}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}

MovementCertificateNumberWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default MovementCertificateNumberWidget



// WEBPACK FOOTER //
// ./src/modules/invoice/component/manage/MovementCertificateNumberWidget.js